import { useLayoutEffect, useRef } from 'react';

const useElementHeightCssVar = <T extends HTMLElement>(cssVarName: string) => {
  const elementRef = useRef<T>(null);

  useLayoutEffect(() => {
    const element = elementRef.current;

    if (!element) return undefined;

    const updateHeight = () => {
      const { height } = element.getBoundingClientRect();

      document.documentElement.style.setProperty(
        cssVarName,
        `${Math.ceil(height)}px`,
      );
    };

    updateHeight();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateHeight);

      return () => {
        window.removeEventListener('resize', updateHeight);
      };
    }

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [cssVarName]);

  return elementRef;
};

export default useElementHeightCssVar;
